var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 3.5V2.79791C1.803 2.53821 1.50244 2.0542 1.50244 1.5C1.50244 0.671573 2.17401 0 3.00244 0C3.83087 0 4.50244 0.671573 4.50244 1.5C4.50244 2.02174 4.23606 2.48127 3.83189 2.75H13C13.3033 2.75 13.5768 2.93273 13.6929 3.21299C13.809 3.49324 13.7448 3.81583 13.5303 4.03033L10.5607 7L13.5303 9.96967C13.7448 10.1842 13.809 10.5068 13.6929 10.787C13.5768 11.0673 13.3033 11.25 13 11.25H3.75V15C3.75 15.4142 3.41421 15.75 3 15.75C2.58579 15.75 2.25 15.4142 2.25 15V3.5ZM3.75 9.75V4.25H11.1893L8.96967 6.46967C8.67678 6.76256 8.67678 7.23744 8.96967 7.53033L11.1893 9.75H3.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagOutlined);
export default __webpack_public_path__ + "static/media/flagOutlined.cbccb4bb.svg";
export { ForwardRef as ReactComponent };